module.exports = __webpack_public_path__ + "static/media/security_trading_light.00385885.svg";